import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const subQuotationService = {
  getAll, get, update, remove, downloadPdf,
}

const API_URL = API.BASE_URL + '/v1'

export function getAll(filter = {}) {
  return apiHelper(API_URL).get('/sub-quotations', { params: filter })
}
export function get(uuid) {
  return apiHelper(API_URL).get(`/sub-quotations/${uuid}`)
}
export function update(uuid, data) {
  return apiHelper(API_URL).put(`/sub-quotations/${uuid}`, data)
}
export function remove(uuid) {
  return apiHelper(API_URL).delete(`/sub-quotations/${uuid}`)
}
export function downloadPdf(uuid) {
  return apiHelper(API_URL).get(`/sub-quotations/${uuid}/pdf`, { responseType: 'blob' })
}
